module.exports = __webpack_public_path__ + "img/RenderMan.d4c5ab4f.png";